import { EndlessProcessLoader } from './EndlessProcessLoader';
import { usePendingLoaderFinish } from './finishGate';

interface PendingProcessLoaderProps {
  processId: string;
  messageKey: string;
}

function GatedLoader({ processId, messageKey }: PendingProcessLoaderProps) {
  const { done, onFinished } = usePendingLoaderFinish(processId);
  return <EndlessProcessLoader messageKey={messageKey} done={done} onFinished={onFinished} />;
}

/** Route pending screen for a process: finishes its animation before the route's page shows. */
export function PendingProcessLoader({ processId, messageKey }: PendingProcessLoaderProps) {
  // Keyed so one process never inherits another's finish state when the pending screen is reused.
  return <GatedLoader key={processId} processId={processId} messageKey={messageKey} />;
}
